import { gql } from '@apollo/client';

export const MAKE_SINGLE_PAYMENT_MUTATION = gql`
  mutation makePaymentWebsite($update: PaymentInput) {
    makePaymentWebsite(update: $update) {
      success
      ccPaymentReceipt {
        transactionDate
        settlementDate
        amount
        receipt
      }
      failureReason {
        apiStatus
        apiTimestamp
        failureCode
        failureReason
      }
    }
  }
`;

/** The PayPal RDTO */
export type PayPalResultDTO = {
  getPaypalResponseWebsite: {
    accountNumber?: string;
    transactionDateTime?: Date;
    receipt?: string;
    paypalTrnID?: string;
  };
};

export const GET_PAYPAL_RESPONSE = gql`
  query GetPaypalResponseWebsite($sessionID: String!, $secureSessionToken: String!) {
    getPaypalResponseWebsite(sessionID: $sessionID, secureSessionToken: $secureSessionToken) {
      accountNumber
      transactionDateTime
      receipt
      paypalTrnID
    }
  }
`;
